import { Line, Tiling } from '../types';

export default function getTilingFromLine(
  line: Line,
  width: number,
  tileSize: number,
): Tiling<true> {
  let tiles = new Tiling<true>();

  const dx = line.end.x - line.begin.x;
  const dy = line.end.y - line.begin.y;
  const length = Math.sqrt(dx * dx + dy * dy);

  const center = { x: line.begin.x + dx / 2, y: line.begin.y + dy / 2 };
  const half = {
    x: Math.abs(dx / 2) + Math.abs(width * dy / (2 * length)),
    y: Math.abs(dy / 2) + Math.abs(width * dx / (2 * length)),
  };

  // TODO : Implement it with more efficient algorithm which also minimizes tiles.

  const left = Math.floor((center.x - half.x) / tileSize);
  const top = Math.floor((center.y - half.y) / tileSize);
  const right = Math.ceil((center.x + half.x) / tileSize);
  const bottom = Math.ceil((center.y + half.y) / tileSize);

  for (let row = top; row < bottom; row += 1) {
    for (let column = left; column < right; column += 1) {
      tiles = tiles.plus(row, column, true);
    }
  }

  return tiles;
}
